<template>
  <v-container fluid>
    <v-card>
      <v-expansion-panels v-model="filterExpansionPanel" flat multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $vuetify.lang.t('$vuetify.FILTERS') }}
          </v-expansion-panel-header>
          <v-form @submit.prevent>
            <v-expansion-panel-content>
              <v-row>
                <v-col
                  ccols="12"
                  md="2"
                  sm="6"
                  class="pt-0 d-flex align-center"
                >
                  <v-menu
                    v-model="validFromPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          selectedValidFrom !== ''
                            ? datePickerFormat(selectedValidFrom)
                            : ''
                        "
                        :label="$vuetify.lang.t('$vuetify.STATISTICS.FROM')"
                        :placeholder="
                          $vuetify.lang.t('$vuetify.STATISTICS.FROM')
                        "
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        clearable
                        v-bind="attrs"
                        @click:clear="validFrom = null"
                        @click:append="validFromPicker = !validFromPicker"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="selectedValidFrom"
                      @input="validFromPicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="2" sm="6" class="pt-0 d-flex align-center">
                  <v-menu
                    v-model="validToPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          selectedValidTo !== ''
                            ? datePickerFormat(selectedValidTo)
                            : ''
                        "
                        :label="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                        :placeholder="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        clearable
                        v-bind="attrs"
                        @click:clear="selectedValidTo = null"
                        @click:append="validToPicker = !validToPicker"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="selectedValidTo"
                      @input="validToPicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="zone"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.ZONE')"
                    :aria-label="$vuetify.lang.t('$vuetify.ZONE')"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="carNumber"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')"
                    :aria-label="
                      $vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')
                    "
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="6" class="pt-0 d-flex align-center">
                  <v-btn
                    color="success"
                    type="submit"
                    @click="searchParkingStatusCheckLogs()"
                  >
                    {{ $vuetify.lang.t('$vuetify.SEARCH') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-form>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text>
        <v-data-table
          :items="parkingStatusCheckLogs"
          :headers="[
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.CHECKED_AT'),
              align: 'start',
              sortable: false,
              value: 'createdAt'
            },
            {
              text: $vuetify.lang.t('$vuetify.ZONE'),
              align: 'start',
              sortable: false,
              value: 'placeCode'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_NUMBER'),
              align: 'start',
              sortable: false,
              value: 'licensePlate'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.HAD_PARKING'),
              align: 'start',
              sortable: false,
              value: 'hadParking'
            }
          ]"
          class="elevation-1"
          hide-default-footer
          :items-per-page="11"
          :loading="
            loading.state && loading.type === 'getParkingStatusCheckLogs'
          "
        >
          <template v-slot:item.createdAt="props">
            <td>{{ dateEE(props.item.createdAt) }}</td>
          </template>
          <template v-slot:item.placeCode="props">
            <td>{{ props.item.placeCode }}</td>
          </template>
          <template v-slot:item.licensePlate="props">
            <td>{{ props.item.licensePlate }}</td>
          </template>
          <template v-slot:item.hadParking="props">
            <td v-if="props.item.hadParking">
              <v-icon color="green">mdi-check</v-icon>
            </td>
            <td v-else>
              <v-icon color="red">mdi-close</v-icon>
            </td>
          </template>
        </v-data-table>
        <v-toolbar color="transparent" class="elevation-0">
          <v-spacer></v-spacer>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="currentPageNumber === 0"
            @click="prevPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
          </v-btn>
          <v-btn fab color="primary" class="secondary--text" x-small readonly>
            {{ currentPageNumber + 1 }}
          </v-btn>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="!parkingStatusCheckLogs.length"
            @click="nextPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'ParkingStatusCheckLogs',
  mixins: [formatDate],
  data() {
    return {
      filterExpansionPanel: [0],
      validFromPicker: false,
      selectedValidFrom: '',
      validToPicker: false,
      selectedValidTo: '',
      carNumber: '',
      location: '',
      zone: '',
      currentPageNumber: 0,
      pageSize: 11
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('enforcement', ['parkingStatusCheckLogs'])
  },
  created() {
    // Set selectedValidTo to current day
    this.selectedValidTo = this.formatDate(new Date())
    this.getParkingStatusCheckLogs(
      `from=${this.serverFormat(this.selectedValidFrom)}&to=${this.serverFormat(
        this.selectedValidTo
      )}&page=${this.currentPageNumber}&page_size=${this.pageSize}`
    )
  },
  methods: {
    ...mapActions('enforcement', ['getParkingStatusCheckLogs']),
    dayDiff(startdate, enddate) {
      // Set time to 0, to calculate the day difference by comparing year, month, and day values
      startdate.setHours(0, 0, 0, 0)
      enddate.setHours(0, 0, 0, 0)

      const timeDiff = enddate - startdate
      const dayCount = timeDiff / (1000 * 60 * 60 * 24)

      return Math.floor(dayCount)
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    serverFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    nextPage() {
      if (this.parkingStatusCheckLogs.length) {
        this.currentPageNumber += 1
        this.getParkingStatusCheckLogs(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&carNumber=${this
            .carNumber || ''}&zone=${this.zone || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}`
        )
      }
    },
    prevPage() {
      if (this.currentPageNumber !== 0) {
        this.currentPageNumber -= 1
        this.getParkingStatusCheckLogs(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&carNumber=${this
            .carNumber || ''}&zone=${this.zone || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}`
        )
      }
    },
    searchParkingStatusCheckLogs() {
      this.getParkingStatusCheckLogs(
        `from=${this.serverFormat(
          this.selectedValidFrom
        )}&to=${this.serverFormat(this.selectedValidTo)}&carNumber=${this
          .carNumber || ''}&zone=${this.zone || ''}&page=${
          this.currentPageNumber
        }&page_size=${this.pageSize}`
      )
    }
  }
}
</script>
